import { render, staticRenderFns } from "./CenterAlert.vue?vue&type=template&id=3f16c95b&scoped=true&"
import script from "./CenterAlert.vue?vue&type=script&lang=js&"
export * from "./CenterAlert.vue?vue&type=script&lang=js&"
import style0 from "./CenterAlert.vue?vue&type=style&index=0&id=3f16c95b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f16c95b",
  null
  
)

export default component.exports